// work data

export const Work = [
    {
        id:1,
        name:"Covid-19 Data Analysis and Visualization",
        description:"Effectively web scrapped Covid-19 Nigeria table data from NCDC using standard Python libraries and tools and created a Data Science project called the COVID-19 INTERACTIVE COMPREHENSIVE ANALYSIS AND VISUALIZATION.",
        tags:["python","seaborn","plotly", "folium"],
        
        demo:"https://github.com/Drimdave/Covid-19-Data-Analysis-and-Visualization/blob/master/COVID-19_NIGERIA_REPORT.ipynb",
        github:"https://github.com/Drimdave/Covid-19-Data-Analysis-and-Visualization"
    },
    {
        id:2,
        name:"SF-CRIME CLASSIFICATION",
        description:"Successfully participated in the Kaggle Data Science project, SF-CRIME CLASSIFICATION where I developed an algorithm to predict the category of crimes that occurred in the city by the bay.",
        tags:["python","worldcloud", "sklearn", "xgboost"],
        
        demo:"https://github.com/Drimdave/The-San-Francisco-Crime-Classification/blob/master/The%20San%20Francisco%20Crime%20Classification.ipynb",
        github:"https://github.com/Drimdave/The-San-Francisco-Crime-Classification"
        
    },
    {
        id:3,
        name:"Predicting Customers Churn",
        description:"I creatively employed python to explore, visualize and predict the Customers Churn rate of an undisclosed telecommunication company.",
        tags:["pyhton","pandas","seaborn", "sklearn"],
        
        demo:"https://github.com/Drimdave/Predicting-Customers-Churn/blob/master/Predicting%20Customers%20Churn%20New.ipynb",
        github:"https://github.com/Drimdave/Predicting-Customers-Churn"
    },
    {
        id:4,
        name:"FIFA 19 DATA ANALYSIS VISUALISATION AND PREDICTION",
        description:"I did an end to end walkthrough process of analysing, visualizing and predicting a dataset called the FIFA 19 Game Dataset.",
        tags:["numpy","matplotlib","sklearn", "math"],
        
        demo:"https://github.com/Drimdave/FIFA-19-DATA-ANALYSIS-VISUALISATION-AND-PREDICTION/blob/master/FIFA%2019%20DATA%20ANALYSIS%2C%20VISUALIZATION%20AND%20PREDICTION.ipynb",
        github:"https://github.com/Drimdave/FIFA-19-DATA-ANALYSIS-VISUALISATION-AND-PREDICTION"
       
    }  
  
] 